// extracted by mini-css-extract-plugin
export default {"paymentDetailsContainer":"PaymentDetail_paymentDetailsContainer__Dg-re","info":"PaymentDetail_info__diwxh"};